import { useContext } from 'react';
import { NetworkStatusContext, type NetworkStatusContextValue } from './networkStatusContextStore';

export function useNetworkStatusContext(): NetworkStatusContextValue {
    const context = useContext(NetworkStatusContext);
    if (context === undefined) {
        return { isOnline: true, wasOffline: false };
    }
    return context;
}
